module.exports = __webpack_public_path__ + "img/Hypoxia-BRCA_GSE176078.5d1a2fae.png";